module.exports = __webpack_public_path__ + "img/00-main.d1b984e6.svg";